<mat-card class="padding-none width-100-percent mt-20">
    <mat-card-header>
        <mat-card-title fxLayout="row" fxLayoutAlign="space-between center"
                        style="margin-top: 7px;">
            <div>Últimos RemoteApps</div>
            <button *ngIf="!loading" mat-raised-button type="button" color="primary" class="md-small" (click)="getData()">
                <span *ngIf="!alreadyRead">Show</span>
                <span *ngIf="alreadyRead">Update</span>
            </button>
            <mat-spinner *ngIf="loading" [diameter]="24" color="primary"></mat-spinner>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content  class="scroll-content">
        <table class="statistic-table width-100-percent" cellspacing="0"
               cellpadding="0">
            <thead>
            <tr>
                <th style="width: 50px"></th>
                <th style="width: 250px"></th>
                <th></th>
            </tr>
            </thead>
            <tbody class="body-list">
            <tr *ngFor="let obj of remoteAppsSnapshots">
                <td>
                    <img *ngIf="obj.state.imageBase64" [src]="'data:image/png;base64,' + obj.state.imageBase64" width="32" height="32">
                </td>
                <td>
                    <div>
                        <div><b>{{obj.state.name}}</b></div>
                        <div class="font-size-12"
                             style="margin-bottom: 10px">{{obj.state.app}}</div>
                        <div class="font-size-12"><b>por:</b> {{obj.commitMetadata?.author}}</div>
                        <div class="font-size-12">{{obj.commitMetadata?.commitDate}}</div>
                        <div *ngIf="statusServer.getRemoteApp(obj.state.id, remoteApps) as remoteApp">
                            <ul *ngIf="statusServer.getSubProject(remoteApp?.subProjectId, subProjects) as subProject">
                                <li>
                                    ID:<b> {{statusServer.getCustomerGroup(subProject?.customerGroupId, customerGroups)?.id}} </b>
                                </li>
                                <li>Empresa:
                                    <b>{{statusServer.getCustomerGroup(subProject?.customerGroupId, customerGroups)?.name}} </b>
                                </li>
                                <li>subProject:<b> {{subProject?.name}} </b></li>
                            </ul>
                        </div>
                    </div>
                </td>
                <td>
                    {{obj.commitMetadata.commitDate | timeDiff: 'large'}}
                </td>
            </tr>
            </tbody>
        </table>
    </mat-card-content>
</mat-card>